import { render, staticRenderFns } from "./AllKanbans.vue?vue&type=template&id=79d5ea3f&scoped=true&"
import script from "./AllKanbans.vue?vue&type=script&lang=js&"
export * from "./AllKanbans.vue?vue&type=script&lang=js&"
import style0 from "./AllKanbans.vue?vue&type=style&index=0&id=79d5ea3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d5ea3f",
  null
  
)

export default component.exports